import {throwError as observableThrowError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';

import { UserAttempt } from './../interfaces/user-attempt.model';
import { AjaxResponse } from './../interfaces/ajax-response';


enum attemptStatusEnum {
    STARTED = 'started',
    ENDED = 'ended',
    NOT_STARTED = 'not_started'
}
@Injectable()
export class UserAttemptHelper {
    constructor(
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService,
    ) { }

    getUserAttempt(productCode, itemCode, classid = undefined, assignmentid = undefined, iscbp = false) {
        let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}attempts/user-attempt/${this.apiGatewayHelperService.getSpaceId()}/${productCode}/${encodeURIComponent(itemCode)}`;
        let queryParams = {};
        if (classid) {
            queryParams['classid'] = classid;
        }
        if (assignmentid) {
            queryParams['assignmentid'] = assignmentid;
        }
        if (iscbp) {
            queryParams['iscbp'] = iscbp;
        }
        if (queryParams && Object.keys(queryParams).length > 0) {
            url += '?' + Object.keys(queryParams).map(key => `${key}=${queryParams[key]}`).join('&');
        }
        return this.http.get(url).pipe(
            map(res => {
                const attemptResponse: AjaxResponse<UserAttempt> = {
                    success: res['success'],
                    ...(res['errorCode'] && { errorCode: res['errorCode'] }),
                    ...(res['statusCode'] && { statusCode: res['statusCode'] }),
                    ...(res['data'] && {
                        data: {
                            number: res['data']['attempt_number'],
                            ...(res['data']['attemptid'] && { id: res['data']['attemptid'] }),
                            ...(res['data']['activityid'] && { activityId: res['data']['activityid'] }),
                            submitCount: res['data']['submitCount']
                        }
                    })
                }
                return attemptResponse;
            }
            ), catchError((error) => {
                return observableThrowError(error);
            }));
    }
    getNewAttempt(productCode, itemCode) {
        let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}attempts/new-attempt/${this.apiGatewayHelperService.getSpaceId()}/${productCode}/${encodeURIComponent(itemCode)}`;
        return this.http.get(url).pipe(
            map(res => {
                const attemptResponse: AjaxResponse<UserAttempt> = {
                    success: res['success'],
                    ...(res['errorCode'] && { errorCode: res['errorCode'] }),
                    ...(res['statusCode'] && { statusCode: res['statusCode'] }),
                    ...(res['data'] && {
                        data: {
                            number: res['data']['attempt_number'],
                            ...(res['data']['attemptid'] && { id: res['data']['attemptid'] }),
                            ...(res['data']['activityid'] && { activityId: res['data']['activityid'] })
                        }
                    })
                }
                return attemptResponse;
            }
            ), catchError((error) => {
                return observableThrowError(error);
            }));
    }

    endUserAttempt(productCode, itemCode, attemptid){
        let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}attempts/user-attempt/${this.apiGatewayHelperService.getSpaceId()}/${productCode}/${encodeURIComponent(itemCode)}/${attemptid}`;

        const body = {
            status: attemptStatusEnum.ENDED
        };

        return this.http.put(url, body);
    }
}